export enum LoginProvider {
  FACEBOOK = 'FACEBOOK', // 1
  GOOGLE = 'GOOGLE',
  OWN = 'OWN',
  APPLE = 'APPLE',
}
